import { MemberAuthTool } from '../modules/member-auth-tool';

export const MemberAuthToolPage = (): JSX.Element => <MemberAuthTool />;
